import { render } from "./AggregateTypeSelector.vue?vue&type=template&id=81908f96&scoped=true"
import script from "./AggregateTypeSelector.vue?vue&type=script&lang=js"
export * from "./AggregateTypeSelector.vue?vue&type=script&lang=js"

import "./AggregateTypeSelector.vue?vue&type=style&index=0&id=81908f96&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-81908f96"]])

export default __exports__